import { voiceList, siteMeta } from '@/mocks/homeContent';

const principles = [
  { icon: 'ri-eye-line', title: '只测不吹', desc: '付费推广单独标注，观点来自公开内容与独立观测。' },
  { icon: 'ri-scales-line', title: '口径统一', desc: '排行榜、测评、对比使用同一套评价口径，可比才有意义。' },
  { icon: 'ri-voiceprint-line', title: '敢说真话', desc: '翻车现场、搬运撞车、话术油腻，该点的我们照点不误。' },
  { icon: 'ri-heart-3-line', title: '三观优先', desc: '尊重与边界先行，教人把对方当猎物的话术一律不推荐。' },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="container-x">
        <div className="mb-8 flex flex-col items-center gap-3 text-center md:mb-10">
          <span className="section-eyebrow">
            <i className="ri-message-2-line text-sm" aria-hidden="true"></i>
            关于搭讪吃瓜
          </span>
          <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            我们是谁，为什么做这件事
          </h2>
          <p className="max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            搭讪吃瓜是一个聚焦「社交表达与搭讪内容创作者」的中文观察站。搭讪话题在短视频平台越来越热，
            可博主鱼龙混杂：有人真诚分享、有人贩卖焦虑、有人只会搬套路。我们想做的，就是把它们一个个翻个明白。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-12">
          <div>
            <h3 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-seedling-line text-primary-600" aria-hidden="true"></i>
              编辑部内容原则
            </h3>
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <li key={p.title} className="rounded-2xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                    <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">{p.title}</h4>
                  <p className="mt-1 text-sm leading-6 text-foreground-600">{p.desc}</p>
                </li>
              ))}
            </ul>

            <div className="mt-5 rounded-2xl border border-accent-200 bg-accent-50/70 p-5">
              <h4 className="flex items-center gap-2 font-heading text-base font-bold text-accent-900">
                <i className="ri-flashlight-line" aria-hidden="true"></i>
                我们的立场
              </h4>
              <p className="mt-2 text-sm leading-7 text-foreground-700">
                搭话与社交表达的底层是尊重、真诚与自我成长，不是套路和技巧堆砌。我们测评博主，最终是希望大家在看内容时保有判断力，
                既不盲目神化某位创作者，也不被「学了就能脱单」的话术收割注意力。
              </p>
            </div>
          </div>

          <div>
            <h3 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-chat-quote-line text-primary-600" aria-hidden="true"></i>
              读者怎么看我们
            </h3>
            <div className="flex flex-col gap-3">
              {voiceList.map((v) => (
                <figure key={v.name} className="rounded-2xl border border-background-200 bg-background-50 p-4 shadow-soft">
                  <i className="text-2xl leading-none text-primary-300 ri-double-quotes-l" aria-hidden="true"></i>
                  <blockquote className="mt-1 text-sm leading-7 text-foreground-700">“{v.quote}”</blockquote>
                  <figcaption className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
                    {v.name} · {v.role}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-5 rounded-2xl bg-background-950 p-6 sm:flex-row sm:items-center md:p-8">
          <div className="flex flex-col gap-2">
            <h3 className="font-heading text-xl font-bold text-background-50">看到「翻车」或「好内容」了？</h3>
            <p className="text-sm leading-6 text-background-100/80">
              欢迎投稿爆料或推荐值得测评的搭讪博主，编辑部会跟进核实并归档进月度盘点。
            </p>
          </div>
          <a
            href="mailto:hello@dashanchigua.example"
            className="inline-flex flex-shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-400"
          >
            <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
            联系编辑部
          </a>
        </div>
      </div>
    </section>
  );
}